/**
 * iter284 — Carte de confirmation d'une action préparée par l'assistant.
 * Rien n'est écrit dans le CRM avant le clic sur « Confirmer ».
 */
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Check, X, Loader2, ShieldAlert } from "lucide-react";
import api from "@/lib/api";

export default function AssistantActionCard({ action, onDone }) {
  const [busy, setBusy] = useState(false);
  const [fait, setFait] = useState(false);

  const agir = async (quoi) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/assistant/actions/${action.id}/${quoi}`);
      setFait(true);
      onDone(data.message || "Action traitée", quoi === "confirm" ? !!data.ok : true, data.next_action || null);
    } catch (e) {
      onDone(e.response?.data?.detail || "Action impossible", false);
      setFait(true);
    } finally {
      setBusy(false);
    }
  };

  if (fait) return null;

  return (
    <div
      className="mt-2 rounded-xl border border-amber-300 bg-amber-50/80 p-2.5 text-gray-800"
      data-testid={`assistant-action-${action.action}`}
    >
      <div className="flex items-start gap-1.5">
        <ShieldAlert className="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="text-xs font-semibold" data-testid="assistant-action-resume">{action.resume}</div>
          {!!(action.details || []).length && (
            <ul className="mt-1 space-y-0.5">
              {action.details.map((d, i) => (
                <li key={i} className="text-[11px] text-gray-600">• {d}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="mt-2 flex items-center gap-1.5">
        <Button
          size="sm"
          onClick={() => agir("confirm")}
          disabled={busy}
          className="h-7 text-xs bg-[#52a675] hover:bg-[#3d8a5c]"
          data-testid="assistant-action-confirm"
        >
          {busy ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}
          Confirmer
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => agir("cancel")}
          disabled={busy}
          className="h-7 text-xs text-gray-600"
          data-testid="assistant-action-cancel"
        >
          <X className="w-3 h-3 mr-1" /> Annuler
        </Button>
      </div>
    </div>
  );
}
